class Circle {
  constructor(centerX, centerY, radius, color){
    this.centerX = centerX;
    this.centerY = centerY;
    this.radius = radius;
    this.color = color;
  }
}

export default Circle;



// WEBPACK FOOTER //
// ./src/classes/Circle/index.js